import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Navigation/Flyout/flyoutButton.container"
    ).then((module) => ({
        default: module.FlyoutButtonContainer
    }))
);
